import qs from 'qs';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import { getDateRangeFromCalendar } from '../../shared/calendar';
import { getGroupValues } from '../../shared/groups';

export default (chainState, externalQuery = {}) => {
	const {
		query,
		calendar,
		filters: { selectedFilters },
		groups = null,
		quickFilters,
		search,
		switchControlMultiStatus: { filters }
	} = cloneDeep(chainState);

	const dateRange = getDateRangeFromCalendar(calendar);

	if (dateRange) {
		query['date_range'] = dateRange;
	}

	if (selectedFilters) {
		const filters = {};
		const inverseFilters = {};

		selectedFilters.forEach(filter => {
			const values = filter.value.map(f => f.value);
			if (values.length) {
				const selectedFilterValues = filter.shouldInverse ? inverseFilters : filters;
				selectedFilterValues[filter.name] = values;
			}
		});

		query['filters'] = !isEmpty(filters) ? filters : {};
		query['inverse_filters'] = !isEmpty(inverseFilters) ? inverseFilters : {};
	}

	if (groups) {
		const { listOfControls, orderControlsDuration } = groups;
		const groupValues = getGroupValues(listOfControls, orderControlsDuration);
		groupValues && (query['groups'] = groupValues);
	}

	const externalQueryPrepare = isEmpty(externalQuery) ? {} : {
		...externalQuery,
		currency: externalQuery.currency ? externalQuery.currency : undefined
	};

	const mark = quickFilters.filter(el => el.active === true && el.name !== 'all').map(el => el.name);
	const status = filters.filter(el => el.active === true && el.name !== 'all').map(el => el.name);

	return qs.stringify({
		...query,
		search,
		quick_filters: {
			mark,
			status
		},
		...externalQueryPrepare
	});
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/chaining/shared/get-request-query.js